import { render, staticRenderFns } from "./c-calendar-test@.vue?vue&type=template&id=c74dc98c&"
import script from "./c-calendar-test@.vue?vue&type=script&lang=ts&"
export * from "./c-calendar-test@.vue?vue&type=script&lang=ts&"
import style0 from "./c-calendar-test@.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports